module.exports = __webpack_public_path__ + "media/images/favicons/apple-touch-icon-180x180-f3a996134219c52778b101ec754baff1.png";